import $http from '../../shared/http';

export const head_count_types = {
  namespaced: true,
  state: () => {
    return {
      headCountTypes: null,
      headCountTypeData: null,
    };
  },
  getters: {
    getHeadCountTypes: (state) => state.headCountTypes,
    getHeadCountTypeData: (state) => state.headCountTypeData,
  },
  mutations: {
    setHeadCountTypes: (state, payload) => (state.headCountTypes = payload),
    setHeadCountTypeData: (state, payload) => (state.headCountTypeData = payload),
  },
  actions: {
    async loadHeadCountTypesAction({ commit }) {
      return $http('v2')
        .get(`head_count_types`, { canBeImpersonated: true })
        .then((response) => {
          commit('setHeadCountTypes', response.data.data);
          return response;
        });
    },
  },
};
